// ABOUTME: Route for /chat/$conversationId. Renders nothing — ChatLayout handles display.
// ABOUTME: Exists to register the route param in the file-based route tree.

import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/_chat/chat/$conversationId",
)({
  component: () => null,
});
